<mat-icon
  [class]="color == 'primary' ? 'mat-primary' : 'white'"
  *ngIf="tooltipKey && !rwdService.isSmallDevice"
  [matTooltip]="tooltipKey | locLabel"
  matTooltipPosition="after"
  matTooltipClass="infotip"
>
  {{ icon }}
</mat-icon>

<button
  class="tooltip-button"
  [class.color]="color == 'primary' ? 'mat-primary' : 'white'"
  *ngIf="tooltipKey && rwdService.isSmallDevice"
  type="button"
  #tooltipClickable="matTooltip"
  [matTooltip]="tooltipKey | locLabel"
  matTooltipPosition="after"
  matTooltipClass="infotip"
  (click)="tooltipClickable.toggle()"
>
  <mat-icon> {{ icon }} </mat-icon>
</button>
